import type { State } from '@atlassian/jira-software-burn-reports-common/src/common/types.tsx';
import { getSprintFilterRank } from '@atlassian/jira-software-burn-reports-common/src/common/utils/filters/index.tsx';
import type {
	SprintReportsFilters,
	BurnupChartData,
	SprintScopeChangeData,
	ScopeSprintIssue,
} from '../common/types';

export const getTrackEventContextAttributes = (
	state: State,
	filters: SprintReportsFilters | null,
): {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
} => ({
	estimationStatistic: state.estimation,
	sprintFilterRank: getSprintFilterRank(
		filters && filters.sprints,
		state.sprint && state.sprint.id,
	),
	totalSprints: filters && filters.sprints.length,
});

export const convertChartsDataSecondsToHours = (chart: BurnupChartData): BurnupChartData => {
	const secondsInHour = 3600;

	let { sprintStartEvent, sprintEndEvent } = chart;
	const { scopeChangeEvents } = chart;

	const convertIssueListItemToHours = (issue: ScopeSprintIssue) => ({
		...issue,
		estimate: issue.estimate / secondsInHour,
	});

	const convertScopeChangeEventToHour = (event: SprintScopeChangeData) => ({
		...event,
		scope: event.scope / secondsInHour,
		completion: event.completion / secondsInHour,
		estimate: event.estimate / secondsInHour,
		prevScope: event.prevScope / secondsInHour,
		prevCompletion: event.prevCompletion / secondsInHour,
		prevEstimate: event.prevEstimate / secondsInHour,
	});

	if (sprintStartEvent) {
		sprintStartEvent = {
			...sprintStartEvent,
			scopeEstimate: sprintStartEvent.scopeEstimate / secondsInHour,
			issueList: sprintStartEvent.issueList.map(convertIssueListItemToHours),
		};
	}

	if (sprintEndEvent) {
		sprintEndEvent = {
			...sprintEndEvent,
			scope: sprintEndEvent.scope / secondsInHour,
			completion: sprintEndEvent.completion / secondsInHour,
			issueList: sprintEndEvent.issueList.map(convertIssueListItemToHours),
		};
	}

	return {
		...chart,
		sprintStartEvent,
		sprintEndEvent,
		scopeChangeEvents: scopeChangeEvents.map(convertScopeChangeEventToHour),
	};
};
